import { LetterRequestCustomer_Device_Interface } from './LetterRequestCustomer_Device_Interface';

export interface LetterRequestCustomer_List_Interface {
  id:number,
  code:String,
  code2:String,
  letterCode:String,
  customerId:Number,
  letterType:string,
  customer:String,
  subject_name:String,
  giver_name:String,
  codePeygiri:String,
  giver_semat:String,
  bazgashtBeNamehTarikh:String,
  bazgashtBeNamehShomareh:String,
  draftTitle:String,
  lastSender:String,
  lastGiver:String,
  lastDsc:String,
  lastSection:String,
  lastSection_Id:number,
  lastOrder:String,
  status:Number,
  username:String,
  persianDate:String,
  lastDate:String,
  readed:boolean,
  readedId:String,
  peyvaset:boolean,
  bazgasht:boolean,
  sms:boolean,
  activityVisible:boolean,
  dscVisible:boolean,
  sex:boolean,
  DeletingProccess:boolean,
  deviceCount:Array<number>,
  schedule:Array<String>,
  schedule_single:String,
  detail:Array<LetterRequestCustomer_List_Interface>
}

export function Empty_LetterRequestCustomer_List_Interface():LetterRequestCustomer_List_Interface{
  return{
    id:0,
    code:'',
    letterCode:'',
    code2:'',
    letterType:'',
    customerId:0,
    customer:'',
    giver_name:'',
    bazgashtBeNamehTarikh:'',
    bazgashtBeNamehShomareh:'',
    giver_semat:'',
    draftTitle:'',
    lastSender:'',
    lastGiver:'',
    lastDsc:'',
    lastSection:'',
    lastSection_Id:0,
    lastOrder:'',
    subject_name:'',
    status:0,
    username:'',
    persianDate:'',
    codePeygiri:'',
    lastDate:'',
    peyvaset:false,
    DeletingProccess:false,
    readed:false,
    bazgasht:false,
    sms:false,
    activityVisible:false,
    dscVisible:false,
    sex:false,
    readedId:'',
    deviceCount:[],
    schedule: [],
    schedule_single:'',
    detail:[]
  }
}
